'use strict';

// Import Libraries
import React from 'react';
import classNames from 'classnames';

// Import JSX Modules
import ShippingDeliveryOption from './shipping-delivery-option';
import OneHourPickupDeliveryOption from './one-hour-pickup-delivery-option';
import SameDayPickupDeliveryOption from './same-day-pickup-delivery-option';

// Import JS Modules
import DeliveryOptionCalculator from '../_utils/_delivery-options/calculator';

// -----------------------------------------------------------
//  DeliveryOptions
// -----------------------------------------------------------
const DeliveryOptions = ({ options, products, pickupOpen, shippingOpen, handleOpenPickup, handleOpenShipping }) => {
  const $options = [];
  let productsDeliveryOptions = [];

  for (let product of products) {
    productsDeliveryOptions = productsDeliveryOptions.concat(product.delivery_options);
  }

  const { hasOneHourPickup, hasSameDayPickup, hasShipping } =
    DeliveryOptionCalculator.productsDeliveryOptionsTiers(productsDeliveryOptions, options);

  options.forEach(option => {
    if (!hasShipping) {
      if (DeliveryOptionCalculator.isShipping(option)) {
        $options.push(<ShippingDeliveryOption open={shippingOpen}
          disabled
          handleOpen={handleOpenShipping}
          title={option.title} />);
      }
    } else {
      $options.push(<ShippingDeliveryOption open={shippingOpen}
        handleOpen={handleOpenShipping} title={option.title} />);
    }

    if (!hasOneHourPickup && !hasSameDayPickup) {
      if (DeliveryOptionCalculator.isOneHourPickup(option)) {
        $options.unshift(<OneHourPickupDeliveryOption open={pickupOpen}
          disabled
          handleOpen={handleOpenPickup}
          title={option.title} />);

      } else {
        if (DeliveryOptionCalculator.isSameDayPickup(option)) {
          $options.unshift(<SameDayPickupDeliveryOption open={pickupOpen}
            disabled
            handleOpen={handleOpenPickup}
            title={option.title} />);
        }
      }
    } else {
      $options.unshift(<SameDayPickupDeliveryOption open={pickupOpen}
        handleOpen={handleOpenPickup}
        title={option.title} />);
    }
  });

  return (
    <div className='delivery-options'>
      <div className="row">
        <div className={classNames('col-12 col-xl-6', { 'top-divider': $options[0] })}>
          {$options[0]}
        </div>
        <div className={classNames('col-12 col-xl-6', { 'top-divider': $options[1] })}>
          {$options[1]}
        </div>
      </div>
    </div>
  );
};

export default DeliveryOptions;
